import { addStyles } from 'ethcss'
import { IStyles, mediaCSS, colors } from '../../theme'

const ipTvStyles: IStyles = {
    ipTv: {
        [mediaCSS.tabMini]: {
            paddingTop: 60,
        },
    },
    tabsWrapper: {
        display: 'flex',
        marginBottom: 14,
    },
    tabBtn: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '40px',
        color: '#000000',
        transition: 'all 0.2s',
        borderRadius: '7px',
        marginRight: '10px',

        '&:last-child': {
            marginRight: 0,
        },

        '&:hover': {
            backgroundColor: '#DBDBDB',
            cursor: 'pointer',
            borderColor: '#DBDBDB',
        },
    },
    tabActive: {
        background: '#DBDBDB',
    },
    wrapper: {
        border: `1px solid ${colors.grey}`,
        borderRadius: 5,
        overflow: 'hidden',
    },
    channelsHeader: {
        fontWeight: 700,
        borderTop: `1px solid ${colors.grey}`,
    },
    checkboxHeader: {
        marginLeft: 34,
    },
    listWrapper: {
        position: 'relative',
    },
    checkbox: {
        display: 'flex',
        minWidth: 92,
    },
    handle: {
        marginRight: 20,
    },
    channelName: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        marginLeft: 40,
        width: '25%',
        minWidth: '60px',
        [mediaCSS.desktopML]: {
            width: '20%',

            [mediaCSS.desktopLM]: {
                marginLeft: 40,
                width: '15%',
            },
        },
    },
    channelNumber: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        width: '10%',

        marginLeft: 14,
        minWidth: 50,

        [mediaCSS.desktopLM]: {
            marginLeft: 20,
            width: '6%',
            minWidth: 30,
            [mediaCSS.desktopLM]: {
                width: '10%',
            },
        },
    },
    channelUrl: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        marginLeft: -8,
        width: '12%',
        minWidth: '60px',
        [mediaCSS.desktopML]: {
            width: '15%',

            [mediaCSS.desktopLM]: {
                width: '10%',
            },
        },
    },
    channelLogo: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 14,
        width: 60,

        [mediaCSS.desktopLM]: {
            marginLeft: 20,
        },

        img: {
            maxWidth: '100%',
            maxHeight: '100%',
        },
    },
    tableDisplay: {
        flexWrap: 'wrap',
        display: 'table',
        width: '100%',
        minWidth: 1550,
    },
    widthFull: {
        width: '100%',
    },
    scrollWrapper: {
        overflowY: 'hidden',
        overflowX: 'auto',
        width: '100%',
    },
    channelCategory: {
        width: '12%',
        marginLeft: 15,
        minWidth: '60px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        [mediaCSS.desktopML]: {
            width: '15%',
            marginLeft: 40,
        },
    },
    channelPreset: {
        width: '10%',
        marginLeft: 60,
        minWidth: '60px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        [mediaCSS.desktopML]: {
            width: '15%',
            marginLeft: 40,
        },

        span: {
            textDecoration: 'line-through',
        },
    },
    channelVisibility: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        minWidth: 70,
        marginLeft: 20,
    },
    channelChangeButtons: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        opacity: 0,
        transition: 'opacity 0.3s',
        padding: '7px 8px',
        borderRadius: 7,
        backgroundColor: colors.white,
        flexShrink: 0,
    },
    changeButtons: {
        display: 'flex',
        position: 'absolute',
        right: 14,
        top: '50%',
        transform: 'translateY(-50%)',
        opacity: 0,
        transition: 'opacity 0.3s',
        padding: '7px 10px 7px 0',
        borderRadius: 7,
        backgroundColor: colors.white,

        '& >div': {
            marginLeft: 10,
        },
    },
    channel() {
        const self = this

        return {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            borderTop: `1px solid ${colors.grey}`,
            padding: 14,
            height: 70,
            overflow: 'hidden',
            lineHeight: 1.2,
            '&:hover': {
                [`& .${self.channelChangeButtons}`]: {
                    opacity: 1,
                },
            },

            [mediaCSS.tab]: {
                paddingRight: 66,
            },
        }
    },

    categoriesHeader: {
        fontWeight: 700,
        borderTop: `1px solid ${colors.grey}`,
    },
    categoryName: {
        marginLeft: 40,
        width: 'calc(100% - 308px)',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        [mediaCSS.tabMini]: {
            width: '100%',
        },
    },
    category() {
        const self = this

        return {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            borderTop: `1px solid ${colors.grey}`,
            padding: 14,
            height: 70,
            lineHeight: 1.2,
            overflow: 'hidden',

            '&:hover': {
                [`& .${self.changeButtons}`]: {
                    opacity: 1,
                },
            },

            [mediaCSS.tab]: {
                paddingRight: 66,
            },
        }
    },

    searchBar: {
        display: 'flex',
        height: 41,
        border: `1px solid ${colors.grey}`,
        borderRadius: 5,
        marginBottom: 14,
        backgroundColor: colors.white,
    },
    search: {
        position: 'relative',
        width: '85%',

        [mediaCSS.tab]: {
            width: '70%',
        },
    },
    dropdown: {
        width: '15%',

        [mediaCSS.tab]: {
            width: '30%',
        },
    },
    searchInput: {
        border: 'none',
    },
    dropdownBtn: {
        button: {
            border: 'none',
            borderRadius: '0 !important',
            borderLeft: `1px solid ${colors.grey}`,
            background: 'none',
        },
    },
    checkboxItem: {
        backgroundColor: 'red',
    },
    deleteConfirmWrapper: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10000,
        backgroundColor: 'rgba(0,0,0,0.7)',
    },
    deleteConfirm: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: '600px',
        transform: 'translate(-50%, -50%)',
        background: colors.white,
        textAlign: 'center',
        padding: 34,
        borderRadius: 20,

        [mediaCSS.tabMini]: {
            width: 320,
        },
    },
    controls: {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '24px auto 0 auto',
        maxWidth: 210,
    },
    button: {
        display: 'flex',
        justifyContent: 'center',
        width: 100,
    },
    groupName: {
        marginLeft: 40,
        width: '30%',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    groupDevicesCount: {
        marginLeft: 40,
        width: 180,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    categoryInUse: {
        marginLeft: 40,
        width: 180,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },

    group() {
        const self = this

        return {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            borderTop: `1px solid ${colors.grey}`,
            padding: 14,
            height: 70,
            lineHeight: 1.2,
            overflow: 'hidden',

            '&:hover': {
                [`& .${self.changeButtons}`]: {
                    opacity: 1,
                },
            },

            [mediaCSS.tab]: {
                paddingRight: 66,
            },
        }
    },
    viewN: {
        textDecoration: 'underline',
        color: colors.blueAccent,
        cursor: 'pointer',

        '&:hover': {
            textDecoration: 'none',
        },
    },
    modalTimer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 50,
        marginTop: 14,
    },
    hint: {
        textAlign: 'center',
    },
    section: {
        borderRadius: 6,
        width: '100%',
        padding: '24px 60px',
        backgroundColor: colors.water,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        alignItems: 'center',
    },
}

addStyles(ipTvStyles)
export default ipTvStyles
